import React from 'react';
import { Container } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function Hero() {
  return (
    <div className="relative w-full py-20 md:py-32 bg-cover bg-center text-white flex items-center justify-center text-center">
      <img 
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/2c5891aada7f853efe6dd8b6de2808a048b4525b26e51f166f610236b96a5972?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
        alt="Background"
      />
      <div className="absolute inset-0 bg-black/40"></div>
      <Container>
        <div className="relative z-10">
          <Heading level="h1" className="text-4xl md:text-5xl font-bold mb-4">Prepare for Your Interview</Heading>
          <Text className="text-lg md:text-xl">
            Follow the instructions below to ensure a smooth interview experience. 
            Test your microphone, speakers, and camera before starting.
          </Text>
        </div>
      </Container>
    </div>
  );
}

export default Hero;
